import styled from "styled-components";

export const WordSC = styled.div`
  padding: 3px 10px;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
`;
